import { render } from "./EduRegisterConfirmPage.vue?vue&type=template&id=b5b24a1a&scoped=true"
import script from "./EduRegisterConfirmPage.vue?vue&type=script&lang=js"
export * from "./EduRegisterConfirmPage.vue?vue&type=script&lang=js"

import "./EduRegisterConfirmPage.vue?vue&type=style&index=0&id=b5b24a1a&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5b24a1a"]])

export default __exports__